import {
  Alert,
  AlertIcon,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import Container from '../components/Container';
import { confirmUser } from '../services';
import Spinner from '../components/Spinner';

const ConfirmUserPage = () => {
  const [status, setStaus] = useState('loading');
  const [message, setMessage] = useState('loading');

  useEffect(() => {
    let ignore = false;
    const [rta, abortController] = confirmUser();

    rta.then((d = {}) => {
      if (!ignore) {
        if (d.status === 'redirect') {
          window.location.replace(d.url);
        } else if (d.status === 'ok') {
          setStaus('info');
          setMessage(d.message);
        } else {
          setStaus('error');
          setMessage(d.message || 'Unexpected error');
        }
      }
    });
    return () => {
      ignore = true;
      abortController.abort();
    };
  }, []);

  return (
    <Container>
      {status === 'loading'
        ? <Spinner />
        : (
          <Alert status={status}>
            <AlertIcon />
            {message}
          </Alert>
        )}
    </Container>
  );
};

export default ConfirmUserPage;
